// src/resources/Configuration.js
import React from 'react';
import { Edit, SimpleForm, TextInput, NumberInput, Title } from 'react-admin';
import { Card, CardContent, Typography } from '@mui/material';

const ConfigurationTitle = () => <Title title="App Settings" />;

export const ConfigurationEdit = (props) => (
    <Edit
        {...props}
        resource="config"
        id="app-settings" // This is a fixed ID for our single settings record
        title={<ConfigurationTitle />}
        actions={null} // We don't need the default list/delete buttons
        redirect={false} // Stay on the page after saving
    >
        <SimpleForm>
            {/* === البطاقة الجديدة التي تم إضافتها === */}
            <Card sx={{ padding: 2, marginBottom: 2 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>Fair Price Calculation</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                        Controls for the "Fair Price" suggestion algorithm.
                    </Typography>
                    <NumberInput
                        source="FUEL_PRICE_PER_LITER"
                        label="Fuel Price (per Liter)"
                        step={0.01}
                        helperText="e.g., 19.25"
                    />
                    <NumberInput
                        source="AVG_KM_PER_LITER"
                        label="Average KM per Liter"
                        step={0.1}
                        helperText="e.g., 10.0"
                    />
                    <NumberInput
                        source="DEPRECIATION_PER_KM"
                        label="Depreciation (per KM)"
                        step={0.1}
                        helperText="e.g., 1.2"
                    />
                    <NumberInput
                        source="DEFAULT_SEATS_TO_SHARE"
                        label="Seats to Share (Total)"
                        helperText="Total cost will be divided by this number (e.g., 4 = Driver + 3 Passengers)"
                        min={1}
                        step={1}
                    />
                </CardContent>
            </Card>

            {/* --- البطاقات القديمة (لا تزال مستخدمة) --- */}
            <Card sx={{ padding: 2, marginBottom: 2 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>Map Settings</Typography>
                    <NumberInput
                        source="RIDE_DATE_WINDOW_DAYS"
                        label="Ride Date Window (Days)"
                        helperText="Number of upcoming days to show rides on the home map."
                        min={1}
                        max={30}
                        step={1}
                    />
                </CardContent>
            </Card>

            <Card sx={{ padding: 2 }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>Payment Information</Typography>
                    <TextInput source="VODAFONE_CASH_NUMBER" label="Vodafone Cash" fullWidth />
                    <TextInput source="ORANGE_CASH_NUMBER" label="Orange Cash" fullWidth />
                    <TextInput source="INSTAPAY_INFO" label="InstaPay" fullWidth />
                </CardContent>
            </Card>
        </SimpleForm>
    </Edit>
);